module.exports = __webpack_public_path__ + "static/nestted-gif-2ceb799894c045e40e7f6fe8e763b57d.gif";